import {TaksitEntity} from "@/entity/TaksitEntity";

export class TaksitHesapAyarEntity {
    takip_id!: number;
    taksit_baslangic_tarihi!: Date;
    taksit_periyod_sayisi!: number;
    taksit_periyodu!: string;
    taksit_sayisi!: number|null;
    taksit_turu!: number;
    faiz_var_mi:boolean = false;
    feragat_var_mi!:boolean;
    feragat_tutar!:number;
    taksit_tutari!: number | null;
    haftasonu_taksit_olmasin: boolean = false;
    taksit_tutari_yuvarlansin_mi: boolean = false;
    taksitler : Array<TaksitEntity> = [];
    ana_para!: number;
    isleyen_faiz!: number;
    toplam_borc!: number;
    hesaplansin_mi:boolean=false;
    baro_vekalet_pulu_gosterilsin_mi: boolean = true;
    vekalet_suret_harci_gosterilsin_mi: boolean = true;
    pesin_harc_gosterilsin_mi: boolean = true;
    // TDT-3107: Taahhüdü veren borçlu(lar). Boş => dosyadaki tüm borçlular gösterilir.
    secilen_borclu_idleri: Array<number> = [];
}